
































































































import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { ClickUpUrlForGiveFeedbackLink } from '../lib/constants';
import { isMobile, isTablet, isDesktop } from '../lib/utilities/breakpoints';
import { VuexLocalStorage } from '../lib/vuexLocalStorage';

const storage = new VuexLocalStorage('_USER_');
const clientStorage = new VuexLocalStorage('_CLIENT_');
const userPreferenceStorage = new VuexLocalStorage('_USER_PREFERENCE_');

const navSizes = {
  small: 'small',
  medium: 'medium',
  large: 'large'
};

export default Vue.extend({
  name: 'Navigation',
  data() {
    return {
      navSizes,
      navWidth: undefined, // set on created,
      isMenuOpen: false
    };
  },
  computed: {
    ...mapGetters('feature', ['showGrowthCampaigns']),
    ...mapState('inbox', ['unreadThreadsCount']),
    ...mapGetters('user', ['accountManagementAllowed', 'isClientSession']),
    ...mapGetters('client', [
      'isActiveClient',
      'isInternationalClient',
      'isTelkomClient'
    ]),
    isAdminNav(): boolean {
      return this.$route.fullPath.startsWith('/admin') && this.$auth.isAdmin;
    },
    isLargeNav() {
      return isDesktop(this.$vuetify);
    },
    isMidNav() {
      return isTablet(this.$vuetify);
    },
    isSmallNav() {
      return isMobile(this.$vuetify);
    },
    menuIcon() {
      return this.isMenuOpen ? 'mdi-close' : 'mdi-menu';
    },
    hideWhenOpenMenu() {
      return !this.isLargeNav && this.isMenuOpen;
    },
    mainNavItems() {
      return this.navigationList.filter(item => item.mainNav === true);
    },
    clientNavItems() {
      return this.navigationList.filter(item => item.show !== false);
    },
    navigationList() {
      return [
        {
          label: 'Campaigns',
          to: '/campaigns',
          show: !this.isLargeNav,
          mainNav: true
        },
        {
          label: 'Automations',
          to: '/automations',
          show: !this.isLargeNav,
          mainNav: true
        },
        {
          label: 'Growth tools',
          to: '/growth-tools',
          show:
            this.showGrowthCampaigns &&
            !this.isTelkomClient &&
            !this.isLargeNav,
          mainNav: true
        },
        {
          label: 'All contacts',
          to: '/contacts/subscribers',
          show: !this.isLargeNav
        },
        {
          label: 'Contacts',
          show: false,
          mainNav: true,
          childNavItems: [
            { label: 'All contacts', to: '/contacts/subscribers' },
            { label: 'Lists', to: '/contacts/lists' }
          ]
        },
        { label: 'Lists', to: '/contacts/lists', show: !this.isLargeNav },
        {
          label: 'Inbox',
          to: '/inbox/all',
          show: !this.isTelkomClient && !this.isLargeNav,
          badge: this.unreadThreadsCount,
          mainNav: true,
          hasDivider: true
        },
        {
          label: 'Settings',
          to: '/account-management/settings/notifications',
          show: this.accountManagementAllowed
        },
        {
          label: 'Integrations',
          to: '/integrations',
          show: this.showIntegrationsPage
        },
        {
          label: this.$route.fullPath.startsWith('/admin')
            ? 'Exit administrations'
            : 'Administrations',
          to: this.$route.fullPath.startsWith('/admin')
            ? '/'
            : '/admin/clients',
          show: this.$auth.isAdmin,
          hasDivider: this.isLargeNav ? true : false
        },
        {
          label: 'Help center',
          href: this.$t('knowledgeBaseLinks.helpCentreLink'),
          external: true,
          hasDivider: this.isLargeNav ? true : false
        },
        {
          label: 'Share feedback',
          external: true,
          href: ClickUpUrlForGiveFeedbackLink,
          hasDivider: this.isLargeNav ? false : true
        },
        {
          label: 'Log out',
          click: this.logout,
          class: 'primary--text'
        }
      ];
    }
  },

  watch: {
    '$vuetify.breakpoint.width'() {
      this.resetNavWidth();
    }
  },
  created() {
    this.resetNavWidth();
  },

  methods: {
    ...mapActions('subscription', [
      'loadPlans',
      'loadMySubscription',
      'loadAddons',
      'loadCharges',
      'loadCardInfo'
    ]),
    ...mapActions('user', ['adminClientSessionDelete']),
    navigateToContactsPath(path) {
      this.$router.push(path);
    },
    menuChange(value) {
      this.isMenuOpen = value;
    },
    navigateToCampaignsDashboard() {
      this.$router.push('/dashboard');
    },
    resetNavWidth() {
      const width = this.$vuetify.breakpoint.width;
      if (width > 1120) return (this.navWidth = navSizes.large);
      if (width >= 600) return (this.navWidth = navSizes.medium);
      return navSizes.small;
    },
    async logout() {
      if (this.isClientSession) {
        this.logoutClientSession();
      } else {
        storage.clearStorageOnly();
        clientStorage.clearStorageOnly();
        userPreferenceStorage.clearStorageOnly();
        this.$intercom.signOut();

        this.$hubspot.clearCookies();

        await this.$auth.logout({
          returnTo: window.location.origin
        });
      }
    },
    async logoutClientSession() {
      const response = await this.adminClientSessionDelete({});
      if (response.success) {
        this.$router.push({
          path: '/',
          query: { 'forward[path]': '/admin/clients' }
        });
      } else
        this.$nuxt.$emit('notify', {
          message:
            response?.errors?.base?.detail ??
            this.$t('errors.unexpectedDefaultMessage'),
          type: 'error'
        });
    }
  },
  async fetch() {
    await Promise.all([this.loadMySubscription(), this.loadPlans()]);
  }
});
